import * as Survey from '@core/survey/survey'
import * as Validation from '@core/validation/validation'

export const stateKey = 'info'

// ====== UPDATE

export const { markDraft } = Survey

export const { assocValidation } = Validation
